<template>
	<div>
		<el-row class="logo-title">
		  <el-col class="flex" :span="IsPC() ? 14 : 24" :offset="IsPC() ? 4 : 0">
		    <div class="logo">
		      <img :src="logo" alt="Logo" />
		    </div>
		    <div class="title">
		      <h1
		        class="title-english"
		      >Ginkgo Fellows in COVID-19 Relief Action</h1>
		      <h1 class="title-chinese">银杏在行动</h1>
		    </div>
		  </el-col>
		</el-row>
		<div class="container">
			<el-row class="header-wrap flex sticky">
			<el-col :span="4" v-if="IsPC()"></el-col>
			<el-col :span="IsPC() ? 16 : 24" class="firstNav flex">
				<router-link :to="{ name: 'Home', params: {activeSub: 'home', currentLang: currentLang}}" v-if="currentLang == 'zh'"><span class="nav" >首页</span></router-link>
				<router-link :to="{ name: 'Home', params: {activeSub: 'home', currentLang: currentLang}}" v-else><span class="nav" >Home</span></router-link>
				<span v-for="item in navs" :key="item.nav">
					<router-link :to="{ name: 'Home', params: {activeSub: item.nav , subShow: true, currentLang: currentLang} }">
						<span class="nav" v-if="currentLang == 'zh'">{{item.titleZH}}</span>
						<span class="nav" v-else>{{item.titleEN}}</span>
					</router-link>
				</span>
			</el-col>
			<el-col :span="4" v-if="IsPC()"></el-col>
			</el-row>
		</div>
		<div class="flex" id="richText" style="margin-top: 30px">
				<el-col :span="4" v-if="IsPC()"></el-col>
				<el-col :span="IsPC() ? 16 : 24">
					<div v-html="conference.information" > 
					</div>  
				</el-col>
				<el-col :span="4" v-if="IsPC()"></el-col>
		</div>
	</div>
	
</template>

<script>
	import logo from '@/assets/logo.png';
	
	export default {
		data() {
			return {
                currentLang: '',
				id: [],
				conference: [],
				logo,
				navs: [
						{
							nav: 'exchange',
							titleZH: '国际交流项目',
							titleEN: 'International Exchange',
							isSubShow: false,
							subNavs:[
								{
											nav: 'exchangeIntro',
											titleZH: '项目介绍',
											titleEN: 'Introduction',
								},
								{
											nav: 'cases',
											titleZH:'项目案例',
											titleEN: 'Cases',
								},
								{
											nav: 'seminars',
											titleZH: '线上会议',
											titleEN: 'Webinars',
								},
								{
											nav: 'contactUs',
											titleZH: '联系我们',
											titleEN: 'Contact Us',
								},
							]
						},
						{
							nav: 'guide',
							titleZH: '建议手册',
							titleEN: 'Practical Guide',
							isSubShow: false,
							subNavs: [
								{
											nav: 'guide',
											titleZH: '建议手册',
											titleEN: 'Practical Guide',
								},
								{
											nav: 'FAQ',
											titleZH: '常见问题',
											titleEN: 'FAQs',
								},
								{
											nav: 'about',
											titleZH: '关于我们',
											titleEN: 'About Us',
								},
								{
											nav: 'contact',
											titleZH: '加入我们',
											titleEN: 'Join us'
								},  
							]
						}
	  				  ],
				activeSub: '', 	
			}
		},
		created() {
			this.id = this.$route.params.id;
            this.currentLang = this.$route.params.currentLang;
			this.fetchConference(this.id);
		},
		methods: {
			IsPC() {
				const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
				if (vw <= 520) {
				return false;
				}
				return true;
			},

			fetchConference(ID) {
                if (this.currentLang != 'zh') {
			    var currLangString = "英文";
		        } else if (this.currentLang == 'zh') {
			    var currLangString = "中文";
		        };
				this.$axios
					.get(`pub/conferences?&lang=${currLangString}&id=${ID}`)
					.then(response => {
						this.conference = response;
					})
			},
			
		}
	}
</script>

<style>
@import url('../styles/home.css');	

.container {
	margin-top: 15px;
	padding: 0 !important;
}

.sticky {
	position: sticky;
	z-index: 900;
	top: -1px;

}
</style>
